import * as React from 'react';
import { classes, style } from 'typestyle';
import { horizontal, horizontallySpaced, vertical, verticallySpaced } from 'csstips';
import { mediaTablet, mediaMobileOnly } from '../theme/media';
import { observer } from 'mobx-react';
import { colorWhite } from '../theme/color';
import { px } from 'csx';

const PrismicDOM = require('prismic-dom');

export interface PageHomePricingBenefitsProps {
  className?: string;
  benefits: Array<{
    title: string;
    content: any;
  }>
}

@observer
export class PageHomePricingBenefits extends React.Component<PageHomePricingBenefitsProps, any> {
  render() {
    const { benefits, className } = this.props;

    return (
      <div className={classes(PageHomePricingBenefits.styles.container, className)}>
        {benefits.map((benefit, index) => (
          <div key={index.toString()} className={PageHomePricingBenefits.styles.benefit}>
            <h4>{benefit.title}</h4>
            <div dangerouslySetInnerHTML={{ __html: PrismicDOM.RichText.asHtml(benefit.content) }}/>
          </div>
        ))}
      </div>
    )
  }

  static styles = {
    container: style(
      mediaMobileOnly({
        ...vertical,
        ...verticallySpaced(60)
      }),
      mediaTablet({
        ...horizontal,
        ...horizontallySpaced(30)
      })
    ),
    benefit: style({
      color: colorWhite.toString(),
      flex: 1,
      $nest: {
        '&> h4': {
          margin: px(0),
          fontSize: px(20)
        },
        '& ul': {
          padding: '0 0 0 20px'
        }
      }
    })
  }
}